import React, { useEffect, useMemo } from 'react';
import './ChipSelector.css';

const ChipSelector = ({ items, selectedChips, setSelectedChips }) => {
    

const itemsWithAll = useMemo(() => {
  if (!items.some(item => item.key === 'all')) {
    return [{ key: 'all',tabId:"all", label: 'All' }, ...items];
  }
  return items;
}, [items]);

const handleChipClick = (e,item) => {
  e.preventDefault();
  const isAll = item.key === 'all';
  const isAlreadySelected = selectedChips?.some(chip => chip.key === item.key);

  if (isAll) {
    if (isAlreadySelected) {
      // Unselect "All"
      setSelectedChips([]);
    } else {
      // Select only "All"
      setSelectedChips([item]);
    }
  } else {
    if (selectedChips?.some(chip => chip.key === 'all')) {
      // If "All" was selected, ignore any other selection
      return;
    }

    if (isAlreadySelected) {
      setSelectedChips(prev => prev?.filter(chip => chip.key !== item.key));
    } else {
      setSelectedChips(prev => [...prev, item]);
    }
  }
};


  const isSelected = (item) =>
    selectedChips?.some(chip => chip.key === item.key);

  return (
    <div className="chip_tab_container">

      <div className="chip_tab_result">
        <p className='chip_tab_result_title'>Select Tab to apply memory on it.</p>
      </div>

      {itemsWithAll?.map((item, index) => (
        <div
          key={item.key}
          className={`chip_tab_chip ${isSelected(item) ? 'chip_tab_selected' : ''} ${
            selectedChips?.some(chip => chip.key === 'all') && item.key !== 'all' ? 'chip_tab_disabled' : ''
          }`}
          onClick={(e) =>
            !(selectedChips?.some(chip => chip.key === 'all') && item.key !== 'all') &&
            handleChipClick(e,item)
          }
        >
          {item?.label}
        </div>
      ))}

    </div>
  );
};

export default ChipSelector;
